import { defineComponent, onMounted } from 'vue';
import UTCTimeIndicatorCode from '@/presentation/components/shared/utc-time-indicator/utc-time-indicator.code';

export default defineComponent({
	setup: () => {
		const code = new UTCTimeIndicatorCode();

		onMounted(code.mounted.bind(code));

		return {
			utcTime: code.utcTime,
			shouldUtcWarningBeShown: code.shouldUtcWarningBeShown,
			shouldUtcErrorBeShown: code.shouldUtcErrorBeShown,
			minutesUntilTwelveFifteen: code.minutesUntilTwelveFifteen
		};
	}
});
